// SessionManager.js

let inactivityTimer = null;
let lastActivity = Date.now();

export const setupInactivityTimer = (logoutCallback) => {
  const MAX_INACTIVE_TIME = 10 * 60 * 1000; // 10 min

  const resetTimer = () => {
    lastActivity = Date.now();
  };

  // Monitor REAL user activity
  window.addEventListener("mousemove", resetTimer);
  window.addEventListener("keydown", resetTimer);
  window.addEventListener("click", resetTimer);
  window.addEventListener("touchstart", resetTimer);

  // Only ONE timer should run
  if (inactivityTimer === null) {
    inactivityTimer = setInterval(() => {
      if (Date.now() - lastActivity > MAX_INACTIVE_TIME) {
        logoutCallback();
      }
    }, 5000); // check every 5 sec
  }
};
